import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '@store/constants';

import * as copyActions from './actions/copyActions';
import * as couponActions from './actions/couponActions';
import * as etcActions from './actions/etcActions';

export const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        ...couponActions,
        ...copyActions,
        ...etcActions,
    },
});

export const orderActions = orderSlice.actions;

export default orderSlice.reducer;
